// src/components/UserProfilePage.tsx
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import UserDetails from './User/UserDetails';
import ResetPassword from './User/ResetPassword';
import GenerateToken from './User/GenerateToken';

const UserProfilePage: React.FC = () => {
  const isExternalLogin = localStorage.getItem("isExternalLogin") === "true";
  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
          <UserDetails />
          {!isExternalLogin && <ResetPassword />}
          <GenerateToken />
      </Row>
    </Container>
  );
};

export default UserProfilePage;
